import React, { useState } from "react";

import "./Auth.css";

export default function Auth({ setPage }) {
  const [login, setLogin] = useState("");
  const [pass, setPass] = useState("");

  function checkPass() {
    if (login === "test" && pass === "password") {
      setPage("main");
    } else {
      setLogin("");
      setPass("");
    }
  }

  return (
    <div className="auth">
      <div className="auth-block">
        <div className="auth-title">Temperature Graph</div>

        <div className="auth-pass">
          <div className="auth-pass-row">
            <span>Логин:</span>

            <input
              type="text"
              value={login}
              onChange={(event) => setLogin(event.target.value)}
            />
          </div>

          <div className="auth-pass-row">
            <span>Пароль:</span>

            <input
              type="password"
              value={pass}
              onChange={(event) => setPass(event.target.value)}
            />
          </div>
        </div>

        <div className="auth-btn">
          <button
            disabled={login === "" || pass === ""}
            onClick={() => checkPass()}
          >
            Войти
          </button>
        </div>
      </div>
    </div>
  );
}
